var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3.75H15V3C14.9989 2.60253 14.8404 2.22166 14.5594 1.94061C14.2783 1.65955 13.8975 1.50115 13.5 1.5H7.5C7.10253 1.50115 6.72166 1.65955 6.44061 1.94061C6.15955 2.22166 6.00115 2.60253 6 3V3.75H3.75C3.35253 3.75115 2.97166 3.90955 2.69061 4.19061C2.40955 4.47166 2.25115 4.85253 2.25 5.25V21C2.25115 21.3975 2.40955 21.7783 2.69061 22.0594C2.97166 22.3404 3.35253 22.4989 3.75 22.5H11.25V21H3.75V5.25H6V7.5H15V5.25H17.25V13.5H18.75V5.25C18.7489 4.85253 18.5904 4.47166 18.3094 4.19061C18.0283 3.90955 17.6475 3.75115 17.25 3.75ZM13.5 6H7.5V3H13.5V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9424 15L16 19.9423L14.0575 17.9999L13 19.0575L16 22.0575L22 16.0575L20.9424 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentCheck);
export default __webpack_public_path__ + "static/media/ic-document-check.f88037c4a02cee183d226b276bf4f830.svg";
export { ForwardRef as ReactComponent };